import { t } from 'i18next';
import { ButtonGhost, ButtonSolid } from '@commons/components/Button';
import { Loading, Modal, ModalProps } from 'components';
import Button from 'components/Button';
import { EX4668, EX5225 } from 'config/flags';
import React, { createContext, useContext, useState } from 'react';
import { Modal as ModalRsuite } from 'rsuite';
import styled, { ThemeContext } from 'styled-components';
import { Status, useAsync, useModal } from 'utils/hooks';
import style from './alertContext.module.css';

export const Label = styled.span`
    white-space: pre-line;
    line-height: 1.4;
    font-size: 15px;
`;

export interface AlertProps extends Omit<ModalProps, 'children' | 'open'> {
    visible: boolean;
    onClose: () => void;
    onConfirm: () => void;
    onCancel?: () => void;
    className: string;
    title: string;
    body: React.ReactNode | string;
    action?: string;
    loading?: boolean;
    disabledActions?: boolean;
}

export interface NewAlertProps extends Omit<ModalProps, 'children' | 'open'> {
    visible: boolean;
    onClose: () => void;
    onConfirm: () => void;
    onCancel?: () => void;
    className: string;
    title: string;
    body: React.ReactNode | string;
    action?: string;
    loading?: boolean;
    disabledActions?: boolean;
    size: string;
    cancel: boolean;
}

function Alert({
    visible,
    onClose,
    onCancel,
    onConfirm,
    className,
    title,
    body,
    action,
    loading,
    disabledActions,
    ...props
}: AlertProps) {
    const theme = useContext(ThemeContext);
    return (
        <Modal fullWidth maxWidth="sm" open={visible} onClose={onClose} {...props}>
            <Modal.Title>{title}</Modal.Title>
            <Modal.Content Height="90px">{loading ? <Loading text="" /> : <Label>{body}</Label>}</Modal.Content>
            <Modal.Actions>
                <Button
                    disabled={disabledActions}
                    colorName={theme.colors.Ra}
                    onClick={() => {
                        onClose();
                        onCancel();
                    }}
                    variant="contained"
                >
                    {t('settings.commercialAgreements.sett_buttonComercialAgreementsModalCancelBtn') || 'Cancelar'}
                </Button>

                <Button
                    disabled={disabledActions}
                    colorName={theme.colors.Ra}
                    onClick={onConfirm}
                    variant="outlined"
                    className={action === 'Descartar' || action === 'Vaciar carrito' ? className : ''}
                >
                    <span className={action === 'Descartar' || action === 'Vaciar carrito' ? className : ''}>
                        {action ? action : 'Aceptar'}
                    </span>
                </Button>
            </Modal.Actions>
        </Modal>
    );
}
const icons = (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
            d="M20 35C17.9167 35 15.9653 34.6042 14.1458 33.8125C12.3264 33.0208 10.7431 31.9514 9.39583 30.6042C8.04861 29.2569 6.97917 27.6736 6.1875 25.8542C5.39583 24.0347 5 22.0833 5 20C5 17.9167 5.39583 15.9653 6.1875 14.1458C6.97917 12.3264 8.04861 10.7431 9.39583 9.39583C10.7431 8.04861 12.3264 6.97917 14.1458 6.1875C15.9653 5.39583 17.9167 5 20 5C22.2778 5 24.4375 5.48611 26.4792 6.45833C28.5208 7.43056 30.25 8.80556 31.6667 10.5833V8.33333C31.6667 7.86111 31.8264 7.46528 32.1458 7.14583C32.4653 6.82639 32.8611 6.66667 33.3333 6.66667C33.8056 6.66667 34.2014 6.82639 34.5208 7.14583C34.8403 7.46528 35 7.86111 35 8.33333V15C35 15.4722 34.8403 15.8681 34.5208 16.1875C34.2014 16.5069 33.8056 16.6667 33.3333 16.6667H26.6667C26.1944 16.6667 25.7986 16.5069 25.4792 16.1875C25.1597 15.8681 25 15.4722 25 15C25 14.5278 25.1597 14.1319 25.4792 13.8125C25.7986 13.4931 26.1944 13.3333 26.6667 13.3333H29.5833C28.4444 11.7778 27.0417 10.5556 25.375 9.66667C23.7083 8.77778 21.9167 8.33333 20 8.33333C16.75 8.33333 13.9931 9.46528 11.7292 11.7292C9.46528 13.9931 8.33333 16.75 8.33333 20C8.33333 23.25 9.46528 26.0069 11.7292 28.2708C13.9931 30.5347 16.75 31.6667 20 31.6667C22.6389 31.6667 25 30.875 27.0833 29.2917C29.1667 27.7083 30.5417 25.6667 31.2083 23.1667C31.3472 22.7222 31.5972 22.3889 31.9583 22.1667C32.3194 21.9444 32.7222 21.8611 33.1667 21.9167C33.6389 21.9722 34.0139 22.1736 34.2917 22.5208C34.5694 22.8681 34.6528 23.25 34.5417 23.6667C33.7361 26.9722 31.9861 29.6875 29.2917 31.8125C26.5972 33.9375 23.5 35 20 35ZM21.6667 19.3333L25.8333 23.5C26.1389 23.8056 26.2917 24.1944 26.2917 24.6667C26.2917 25.1389 26.1389 25.5278 25.8333 25.8333C25.5278 26.1389 25.1389 26.2917 24.6667 26.2917C24.1944 26.2917 23.8056 26.1389 23.5 25.8333L18.8333 21.1667C18.6667 21 18.5417 20.8125 18.4583 20.6042C18.375 20.3958 18.3333 20.1806 18.3333 19.9583V13.3333C18.3333 12.8611 18.4931 12.4653 18.8125 12.1458C19.1319 11.8264 19.5278 11.6667 20 11.6667C20.4722 11.6667 20.8681 11.8264 21.1875 12.1458C21.5069 12.4653 21.6667 12.8611 21.6667 13.3333V19.3333Z"
            fill="#0171E6"
        />
    </svg>
);
const closeIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M18.8665 17.2123C19.2827 17.6212 19.2827 18.2845 18.8665 18.6934C18.4502 19.1022 17.7748 19.1022 17.3585 18.6934L12.1087 13.4989L6.8216 18.6916C6.40534 19.1004 5.72997 19.1004 5.31366 18.6916C4.89736 18.2828 4.8974 17.6195 5.31366 17.2106L10.6026 12.0196L5.3122 6.78765C4.89593 6.37882 4.89593 5.71551 5.3122 5.30664C5.72846 4.89777 6.40383 4.89781 6.82014 5.30664L12.1087 10.5404L17.3959 5.34766C17.8121 4.93883 18.4875 4.93883 18.9038 5.34766C19.3201 5.75648 19.3201 6.4198 18.9038 6.82867L13.6149 12.0196L18.8665 17.2123Z"
            fill="#333333"
        />
    </svg>
);

function NewAlert({
    visible,
    onClose,
    onCancel,
    onConfirm,
    className,
    title,
    body,
    action,
    loading,
    disabledActions,
    size,
    cancel,
    ...props
}: NewAlertProps) {
    const theme = useContext(ThemeContext);
    return (
        // @ts-ignore
        <ModalRsuite size="xs" className="modal-alert-handler" open={visible} onClose={onClose} {...props}>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                {!cancel && icons}{' '}
                {!cancel && (
                    <span
                        onClick={() => {
                            onClose();
                            onCancel();
                        }}
                    >
                        {closeIcon}
                    </span>
                )}
            </div>
            <ModalRsuite.Title className={style['modal-title']}>{title}</ModalRsuite.Title>
            <ModalRsuite.Body className={style['modal-content']}>
                {loading ? <Loading text="" /> : body}
            </ModalRsuite.Body>
            <ModalRsuite.Footer className={style['modal-footer']}>
                {cancel ? (
                    <>
                        <ButtonSolid
                            cancelType={true}
                            disabled={disabledActions}
                            onClick={onConfirm}
                            height={40}
                            width={'100%'}
                            margin={'0px'}
                            text={
                                <span
                                    className={action === 'Descartar' || action === 'Vaciar carrito' ? className : ''}
                                >
                                    {action ? action : 'Aceptar'}
                                </span>
                            }
                        />
                        <ButtonGhost
                            disabled={disabledActions}
                            onClick={() => {
                                onClose();
                                onCancel();
                            }}
                            height={40}
                            width={'100%'}
                            margin={'0px 0px 0px 16px'}
                            text={
                                EX5225
                                    ? t('settings.commercialAgreements.sett_buttonComercialAgreementsModalCancelBtn')
                                    : 'Cancelar'
                            }
                        />
                    </>
                ) : (
                    <>
                        {cancel && (
                            <ButtonGhost
                                disabled={disabledActions}
                                onClick={() => {
                                    onClose();
                                    onCancel();
                                }}
                                height={40}
                                width={'100%'}
                                text={
                                    EX5225
                                        ? t(
                                              'settings.commercialAgreements.sett_buttonComercialAgreementsModalCancelBtn',
                                          )
                                        : 'Cancelar'
                                }
                            />
                        )}
                        <ButtonSolid
                            disabled={disabledActions}
                            onClick={onConfirm}
                            height={40}
                            width={'100%'}
                            margin={cancel ? '0px 0px 0px 16px' : ''}
                            text={
                                <span
                                    className={action === 'Descartar' || action === 'Vaciar carrito' ? className : ''}
                                >
                                    {action ? action : 'Aceptar'}
                                </span>
                            }
                        />
                    </>
                )}
            </ModalRsuite.Footer>
        </ModalRsuite>
    );
}
export type AlertState = {
    className: string;
    title: string;
    body: React.ReactNode | string;
    action?: string;
    onConfirm: () => void;
    onCancel?: () => void;
    AlertProps?: AlertProps;
    loading?: boolean;
    async?: Promise<any>;
    asyncResolved?: () => void;
    disabledActions?: boolean;
    cancel: boolean;
    size: string;
};

const initialState = {
    className: '',
    title: '',
    body: '',
    action: undefined,
    onConfirm: () => {},
    loading: false,
    async: undefined,
    asyncResolved: () => {},
    disabledActions: false,
    cancel: false,
    size: 'xs',
};

export interface AlertProviderValue {
    show(options: AlertState);
}

const AlertContext = createContext<AlertProviderValue>(null);

export function AlertProvider({ children }) {
    const alert = useModal();
    const [state, setState] = useState<AlertState>(initialState);
    const { run, status } = useAsync({});
    const show = ({ title, body, action, className, onConfirm, onCancel, size, cancel, ...props }: AlertState) => {
        alert.toggle();
        setState({
            ...state,
            title,
            body,
            action,
            className,
            onConfirm,
            onCancel,
            size,
            cancel,
            ...props,
        });
    };
    const onConfirm = () => {
        state.onConfirm();
        if (typeof state.async === 'undefined') {
            alert.toggle();
        } else {
            run(state.async);
        }
    };

    React.useLayoutEffect(() => {
        switch (status) {
            case Status.Pending:
                setState({ ...state, loading: true, disabledActions: true });
                break;
            case Status.Rejected:
                alert.toggle();
                setState(initialState);
            case Status.Resolved:
                setTimeout(() => {
                    alert.toggle();
                    setState(initialState);
                    state.asyncResolved();
                }, 2000);

                break;
        }
    }, [status]);

    return (
        <>
            <AlertContext.Provider value={{ show }}>{children}</AlertContext.Provider>
            {!!EX4668 ? (
                <NewAlert visible={alert.visibility} onClose={alert.toggle} {...{ ...state, onConfirm }} />
            ) : (
                <Alert visible={alert.visibility} onClose={alert.toggle} {...{ ...state, onConfirm }} />
            )}
        </>
    );
}

export function useAlert() {
    const context = useContext(AlertContext);

    if (context === undefined) {
        throw new Error('useAlert must be used within a AlertProvider');
    }

    return context;
}
